<ng-content select="[icon-before]"></ng-content>
<span class="shrd-uic-text-content">
  <ng-content select="[content]"></ng-content>
</span>
<ng-content select="[icon-after-1]"></ng-content>
<ng-content select="[icon-after-2]"></ng-content>
<ng-content select="[icon-after-3]"></ng-content>
